angular.module('iqxCore')
.controller('ClientInvoicesCtrl', function ($scope, FormSvc, $http, $routeParams, ApiSvc, ApplicationSvc, LanguageSvc) {
    $scope.checkPermissions('CLIENT')
    $scope.customSliceSize = "10"
    $scope.filterRef = ""
    $scope.datefilter={
        "from":moment().subtract(1,'month').toDate(),
        "to":moment().add(1,'month').toDate()
    }

    FormSvc.setOptions($scope,{
      fetchAPI:'callresult/NetClientInvoiceList?pStartDate='+moment($scope.datefilter.from).format("DD/MM/YYYY")+'&pEndDate='+moment($scope.datefilter.to).format("DD/MM/YYYY")+'&pFilterRef=',
      fetchTarget:'Invoices',
      multiRow:true,
      autoEdit:true,
      sliceSize:Number($scope.customSliceSize)
    })
    $scope.fetch()
    .then(function(){
    	if ($scope.userHasRight('VIEWINVOICEBALANCE')) {
    		$scope.getInvoiceTotal()
    	}
    })
    .then( () => {
        if($routeParams.id){
            // /clientinvoices/<docid>
            openInvoiceFromID($routeParams.id)
        }
    })

    var lang = LanguageSvc.lang
    let openInvoiceFromID = (id) => {
        let invoice = findIn($scope.Invoices, id)
        $scope.view(invoice[0])
    }
    const findIn = (arr, searchKey) => {
        return arr.filter(obj => 
            Object.keys(obj).some(key => {
                if (typeof obj[key] === 'string') {
                    return obj[key].includes(searchKey)
                }
            })
        )
    }

    $scope.filterInvoices=function(){
        FormSvc.setOptions($scope,{
          fetchAPI:'callresult/NetClientInvoiceList?pStartDate='+moment($scope.datefilter.from).format("DD/MM/YYYY")+'&pEndDate='+moment($scope.datefilter.to).format("DD/MM/YYYY")+'&pFilterRef='+$scope.filterRef,
          fetchTarget:'Invoices',
          multiRow:true,
          autoEdit:true,
          sliceSize:Number($scope.customSliceSize)
        })
        $scope.fetch()
        .then(function(){
            if ($scope.userHasRight('VIEWINVOICEBALANCE')) {
                $scope.getInvoiceTotal()
            }
        })
    }

    $scope.checkForError=function(string){
		if (string.substring(0, 1) == "9") {
		    return false
		} else {
			return true
		}
    }

    $scope.download=function(invoice){
    	/* Triggers the download */
    	$scope.getFile(invoice, "download")
    }

    $scope.view=function(invoice){
    	$scope.getFile(invoice, "view")
    }

    $scope.getFile=function(invoice, method){
      // MHS 2/5/18 - change of invoice download mechanism - pass InvoiceID parameter and the hub will sort out the rest. Path no longer required. Will also work for self-bill invoices.
    	$http.get('/api/document/doxi',{params:{InvoiceID:invoice.DocID}})
    	.then(function(res){
    		$http.get('/api/document/download?doxi='+res.data)
            .then(function(success){
                switch(method){
                    case 'download':
                        var _newTab = window.open('about:blank', '_blank')
                        setTimeout(function () { // wait a second then fill that blank tab - thus stopping that pesky popup blocker!!
                            _newTab.location.href = '/api/document/download?doxi='+res.data
                        }, 1001)
                    break

                    case 'view':
                        $scope.title=invoice.OurRef || ""
                        $scope.PDFcontent = '/api/document/download?doxi='+res.data
                        FormSvc.modalInfo($scope,'viewInvoice',{choices:[{desc:"Close",type:"primary",code:''}]}, 'lg')
                    break
                }
            }, function(error){
                var invoiceError = "Error ["+error.status+"] " + error.data +"\n\r"+ "The document cannot be reached at the moment." +"\n\r"+lang.client.invoiceNotFoundCustomError
                FormSvc.alert("Error", invoiceError, "error")
            })
		})
		.catch(function(err) {
			FormSvc.alert("Error", err.data, "error")
		})
    }

    $scope.query=function(invoice){
        var data={}
        FormSvc.modalForm($scope, 'queryInvoice', data, 'md', {label:'col-sm-3', data:'col-sm-7'}, $scope.tags)
        .then(function(data){
            return ApiSvc.fetch(
                $scope,
                {
                    fetchAPI:'callresult/NetClientCreatePopup?pDocID='+invoice.DocID+'&pComment='+encodeURIComponent(data.xQuery),
                    fetchTarget:'createPopup',
                    multiRow:false
                }
            )
        })
        .then(function(){
            if ($scope.checkForError($scope.createPopup.pResult)) {
                FormSvc.alert("Query Sent", "Your message has been sent.", "success")
            } else {
                FormSvc.alert("Error!", $scope.createPopup.pResult, "error")
            }
        })
        .catch(function(err){
            if (err && err!="backdrop click" && err!="escape key press") {ApplicationSvc.showMessage('Error',err,true)}
        })
    }

    $scope.getInvoiceTotal=function(){
		return ApiSvc.fetch(
			$scope,
			{
				fetchAPI:'callresult/NetClientInvoiceTotal',
				fetchTarget:'invoiceTotal',
				multiRow:false
			})
		.then(function(){
			$scope.invoiceTotal = $scope.invoiceTotal.pBalance
		})
    }
})
